import { useTranslations } from 'next-intl'
import GoldLinkButton from './GoldLinkButton'

const GetStartedSection = ({
  firstButtonText,
  firstButtonLink,
  secondButtonLink,
  secondButtonText,
  secondButttonPrimary = false,
  locale,
}) => {
  const isPortuguese = locale === 'pt-BR'
  const t = useTranslations(`readytogetStartedSection`)
  return (
    <section className='py-24 border-t text-[#212529] border-[#CCCCCC] '>
      <div className='container text-left text-[18px] md:text-[16px]'>
        <p className='mb-4 font-normal'>{t(`title`)}</p>
        <p className='mb-4 font-light leading-[1.6]'>{t(`text`)}</p>
        <div
          align='center'
          className={`gap-4 sm:gap-3 mt-10 flex ${isPortuguese ? 'flex-col items-start' : ''}  sm:flex-row sm:items-center text-left `}
        >
          {
            firstButtonText
              ?
              <GoldLinkButton
                hasGoldBackground={true}
                href={
                  firstButtonLink
                    ? firstButtonLink
                    : 'https://business.rolzo.com/auth/register'
                }
                isNewTab
                text={firstButtonText ? firstButtonText : 'Start now'}
                className='leading-[1.5] py-[6px]'
              />
              :
              null
          }
          {
            secondButtonText
              ?
              <GoldLinkButton
                hasGoldBackground={secondButttonPrimary ? secondButttonPrimary : false}
                href={
                  secondButtonLink
                    ? secondButtonLink
                    : 'https://calendly.com/rolzo'
                }
                isNewTab
                text={secondButtonText ? secondButtonText : 'Book a demo'}
              />
              :
              null
          }
        </div>
      </div>
    </section>
  )
}

export default GetStartedSection
